import styled from 'styled-components';

export const Overlay = styled.div<{ $isOpen?: boolean }>`
	background-color: ${({ theme }) => theme.colors.background.modalView};
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 999;
	display: ${props => (props.$isOpen ? 'block' : 'none')};
`;

export const Container = styled.div`
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	background-color: ${({ theme }) => theme.colors.background.secondary};
	border-radius: 16px 16px 0 0;
	padding: 24px 16px 4px 16px;
	max-height: 80vh;
	overflow-y: auto;
`;

export const CloseButton = styled.div`
	position: absolute;
	top: 16px;
	right: 16px;
	cursor: pointer;
	width: 24px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;

	svg {
		fill: ${({ theme }) => theme.colors.text.alwaysWhite};
	}
`;

export const Title = styled.div`
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	margin-bottom: 24px;
	text-align: center;
	font-weight: 500;
	font-size: 18px;
`;

export const Section = styled.div`
	color: ${({ theme }) => theme.colors.text.subtitle};
	margin-bottom: 16px;
	font-weight: 500;
	font-size: 16px;
`;

export const SortOptions = styled.div`
	display: flex;
	gap: 12px;
	margin-top: 12px;
	flex-wrap: wrap;
`;

export const SortItem = styled.div<{ $selected?: boolean; $disabled?: boolean; $round?: boolean }>`
	background-color: ${props =>
		props.$selected ? props.theme.colors.transparent.light30 : props.theme.colors.transparent.light10};
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	border-radius: ${props => (props.$round ? '100px' : '4px')};
	padding: 11px 14px;
	cursor: ${props => (props.$disabled ? 'not-allowed' : 'pointer')};
	font-size: 14px;
	opacity: ${props => (props.$disabled ? 0.6 : 1)};
`;

export const FilterChips = styled.div`
	display: flex;
	gap: 12px;
	flex-wrap: wrap;
	margin-top: 12px;
`;

export const Buttons = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	margin-top: 24px;
	margin-bottom: 16px;
`;

